import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
  BlockType,
  Shared,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  tagline: string;
  title: string;
  description: string;
  image: Shared.Props.MediaProp;
  tab: string;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
  blockType: BlockType.PrimaryCollection,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    SecondaryBlock,
    TertiaryBlock,
    tagline,
    title,
    description,
    image,
  }: ContentCollectionItemType) => (
    <Box className="primary-collection-content-collection-two-col-tabs-medium-media-v1 layout403_tab-wrapper">
      <Box className="layout403_image-wrapper">
        <Variants.Image
          alt={image.alt}
          loading="lazy"
          src={image.url}
          className="layout403_image"
        />
      </Box>
      <Box className="layout403_content">
        {tagline && (
          <Box className="margin-bottom margin-xsmall">
            <Variants.TagLine>{tagline}</Variants.TagLine>
          </Box>
        )}
        <Box className="margin-bottom margin-small">
          <Variants.Heading>{title}</Variants.Heading>
        </Box>
        <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
        {renderSecondaryBlock(SecondaryBlock)}
        {renderTertiaryBlock(TertiaryBlock)}
      </Box>
    </Box>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
